import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | 'cookies' | null;
export const Footer = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const modalContent = {
    terms: {
      title: 'Términos y Condiciones',
      content: <div className="space-y-4" data-id="element-145">
          <p data-id="element-146">
            Bienvenido a FinanzasLatinas. Al acceder y utilizar este sitio web,
            aceptas cumplir con los siguientes términos y condiciones.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-147">1. Uso del Contenido</h3>
          <p data-id="element-148">
            Todo el contenido proporcionado en este sitio es solo para fines
            educativos e informativos. No constituye asesoramiento financiero
            profesional.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-149">2. Propiedad Intelectual</h3>
          <p data-id="element-150">
            Todo el contenido, incluyendo textos, gráficos, logos e imágenes, es
            propiedad de FinanzasLatinas y está protegido por las leyes de
            propiedad intelectual.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-151">
            3. Limitación de Responsabilidad
          </h3>
          <p data-id="element-152">
            FinanzasLatinas no se hace responsable de las decisiones financieras
            tomadas basándose en el contenido de este sitio.
          </p>
        </div>
    },
    privacy: {
      title: 'Política de Privacidad',
      content: <div className="space-y-4" data-id="element-153">
          <p data-id="element-154">
            En FinanzasLatinas, respetamos tu privacidad y nos comprometemos a
            proteger tu información personal.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-155">Información que Recopilamos</h3>
          <p data-id="element-156">
            Recopilamos información que nos proporcionas directamente, como tu
            nombre y correo electrónico cuando te registras o te comunicas con
            nosotros.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-157">Uso de la Información</h3>
          <p data-id="element-158">
            Utilizamos tu información para proporcionarte nuestros servicios,
            mejorar tu experiencia y comunicarnos contigo sobre actualizaciones
            y ofertas.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-159">Protección de Datos</h3>
          <p data-id="element-160">
            Implementamos medidas de seguridad para proteger tu información
            personal contra acceso no autorizado o divulgación.
          </p>
        </div>
    },
    cookies: {
      title: 'Política de Cookies',
      content: <div className="space-y-4" data-id="element-161">
          <p data-id="element-162">
            Este sitio web utiliza cookies para mejorar tu experiencia de
            navegación.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-163">¿Qué son las Cookies?</h3>
          <p data-id="element-164">
            Las cookies son pequeños archivos de texto que se almacenan en tu
            dispositivo cuando visitas un sitio web.
          </p>
          <h3 className="font-semibold text-lg" data-id="element-165">
            Tipos de Cookies que Utilizamos
          </h3>
          <ul className="list-disc pl-6 space-y-2" data-id="element-166">
            <li data-id="element-167">
              <strong data-id="element-168">Cookies Esenciales:</strong> Necesarias para el
              funcionamiento básico del sitio.
            </li>
            <li data-id="element-169">
              <strong data-id="element-170">Cookies de Análisis:</strong> Nos ayudan a entender cómo
              los usuarios interactúan con nuestro sitio.
            </li>
            <li data-id="element-171">
              <strong data-id="element-172">Cookies de Marketing:</strong> Utilizadas para
              personalizar anuncios y contenido.
            </li>
          </ul>
          <h3 className="font-semibold text-lg" data-id="element-173">Control de Cookies</h3>
          <p data-id="element-174">
            Puedes controlar y eliminar cookies a través de la configuración de
            tu navegador.
          </p>
        </div>
    }
  };
  return <>
      <footer className="bg-gray-900 text-white py-12" data-id="element-175">
        <div className="container mx-auto px-4" data-id="element-176">
          <div className="flex flex-col md:flex-row justify-between" data-id="element-177">
            <div className="mb-8 md:mb-0" data-id="element-178">
              <h3 className="text-2xl font-bold text-orange-500 mb-4" data-id="element-179">
                FinanzasLatinas
              </h3>
              <p className="text-gray-400 max-w-md" data-id="element-180">
                Transformando la educación financiera en Latinoamérica con
                métodos que realmente funcionan en nuestra realidad económica.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-8" data-id="element-181">
              <div data-id="element-182">
                <h4 className="text-lg font-semibold mb-4" data-id="element-183">Enlaces</h4>
                <ul className="space-y-2" data-id="element-184">
                  <li data-id="element-185">
                    <a href="#inicio" className="text-gray-400 hover:text-white transition-colors" data-id="element-186">
                      Inicio
                    </a>
                  </li>
                  <li data-id="element-187">
                    <a href="#metodo" className="text-gray-400 hover:text-white transition-colors" data-id="element-188">
                      El Método
                    </a>
                  </li>
                  <li data-id="element-189">
                    <a href="#beneficios" className="text-gray-400 hover:text-white transition-colors" data-id="element-190">
                      Beneficios
                    </a>
                  </li>
                </ul>
              </div>
              <div data-id="element-191">
                <h4 className="text-lg font-semibold mb-4" data-id="element-192">Legal</h4>
                <ul className="space-y-2" data-id="element-193">
                  <li data-id="element-194">
                    <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-195">
                      Términos
                    </button>
                  </li>
                  <li data-id="element-196">
                    <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-197">
                      Privacidad
                    </button>
                  </li>
                  <li data-id="element-198">
                    <button onClick={() => setActiveModal('cookies')} className="text-gray-400 hover:text-white transition-colors text-left" data-id="element-199">
                      Cookies
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8" data-id="element-200">
            <p className="text-gray-500 text-sm text-center" data-id="element-201">
              © {new Date().getFullYear()} FinanzasLatinas. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>
      {/* Modal */}
      {activeModal && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-202">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-203">
            <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center" data-id="element-204">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-205">
                {modalContent[activeModal].title}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-206">
                <XIcon size={24} data-id="element-207" />
              </button>
            </div>
            <div className="p-6 text-gray-700" data-id="element-208">
              {modalContent[activeModal].content}
            </div>
            <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 p-6" data-id="element-209">
              <button onClick={() => setActiveModal(null)} className="w-full bg-orange-600 text-white py-3 px-6 rounded-lg hover:bg-orange-700 transition-colors font-semibold" data-id="element-210">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
};